module.exports = __webpack_public_path__ + "img/icon_defaulthead.1bf67cff.png";